export default {}

// Auth actions
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

// Demo actions
export const DEMO = 'DEMO'

// Register actions
export const REGISTER = 'REGISTER'
export const REGISTER_CONFIRM = 'REGISTER_CONFIRM'
export const VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER'
export const RESEND_SMS = 'RESEND_SMS'
export const ENTER_EMAIL = 'ENTER_EMAIL'

// Forgot password actions
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const FORGOT_PASSWORD_CONFIRM = 'FORGOT_PASSWORD_CONFIRM'

// Common Payments actions
export const GET_PAYABLE_FROM = 'GET_PAYABLE_FROM'
export const GET_RELATED_COPARENTS = 'GET_RELATED_COPARENTS'
export const GET_CASES = 'GET_CASES'
export const GET_COPARENTS_CHILDREN = 'GET_COPARENTS_CHILDREN'
export const GET_PAYMENT_STATUSES = 'GET_PAYMENT_STATUSES'
export const DELETE_EXPENSE = 'DELETE_EXPENSE'
export const GET_ALL_EXPENSES = 'GET_ALL_EXPENSES'
export const GET_ALL_RECURRING_EXPENSES = 'GET_ALL_RECURRING_EXPENSES'
export const MARK_AS_PAID = 'MARK_AS_PAID'
export const GET_PAYMENTS_TYPES = 'GET_PAYMENTS_TYPES'

// Pending Payments actions
export const PENDING_EXPENSES_LIST = 'PENDING_EXPENSES_LIST'

// Recurring Expenses
export const RECURRING_EXPENSES_LIST = 'RECURRING_EXPENSES_LIST';
export const RECURRING_EXPENSES_DETAILS = 'RECURRING_EXPENSES_DETAILS';
export const RECURRING_EXPENSES_DETAILS_TABLE = 'RECURRING_EXPENSES_DETAILS_TABLE';
export const RECURRING_EXPENSES_DETAILS_SHARED_TABLE = 'RECURRING_EXPENSES_DETAILS_SHARED_TABLE';
export const RECURRING_DELETE_SCHEDULED_EXPENSE = 'RECURRING_DELETE_SCHEDULED_EXPENSE';
export const RECURRING_EXPENSE_FIND_BY_GUID = 'RECURRING_EXPENSE_FIND_BY_GUID'
export const RECURRING_EXPENSE_SM_UPDATE = 'RECURRING_EXPENSE_SM_UPDATE'
export const RECURRING_EXPENSE_CM_UPDATE = 'RECURRING_EXPENSE_CM_UPDATE'
export const RECURRING_EXPENSE_SE_UPDATE = 'RECURRING_EXPENSE_SE_UPDATE'
export const RECURRING_EXPENSE_INTERVAL_UNITS = 'RECURRING_EXPENSE_INTERVAL_UNITS'

// Spousal Maintenance actions
export const SPOUSAL_MAINTENANCE_ADD_NEW = 'SPOUSAL_MAINTENANCE_ADD_NEW'
export const SPOUSAL_MAINTENANCE_EDIT = 'SPOUSAL_MAINTENANCE_EDIT'
export const SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW = 'SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW'
export const SPOUSAL_MAINTENANCE_FIND_BY_GUID = 'SPOUSAL_MAINTENANCE_FIND_BY_GUID'
export const SPOUSAL_MAINTENANCE_LIST = 'SPOUSAL_MAINTENANCE_LIST'

// Child Maintenance actions
export const CHILD_MAINTENANCE_ADD_NEW = 'CHILD_MAINTENANCE_ADD_NEW'
export const CHILD_MAINTENANCE_EDIT = 'CHILD_MAINTENANCE_EDIT'
export const CHILD_MAINTENANCE_SCHEDULED_ADD_NEW = 'CHILD_MAINTENANCE_SCHEDULED_ADD_NEW'
export const CHILD_MAINTENANCE_FIND_BY_GUID = 'CHILD_MAINTENANCE_FIND_BY_GUID'
export const CHILD_MAINTENANCE_LIST = 'CHILD_MAINTENANCE_LIST'

// Shared Expenses actions
export const SHARED_EXPENSES_ADD_NEW = 'SHARED_EXPENSES_ADD_NEW'
export const SHARED_EXPENSES_EDIT = 'SHARED_EXPENSES_EDIT'
export const SHARED_EXPENSES_SCHEDULED_ADD_NEW = 'SHARED_EXPENSES_SCHEDULED_ADD_NEW'
export const SHARED_EXPENSES_FIND_BY_GUID = 'SHARED_EXPENSES_FIND_BY_GUID'
export const SHARED_EXPENSES_LIST = 'SHARED_EXPENSES_LIST'

// Transaction history actions
export const TRANSACTION_HISTORY_LIST = 'TRANSACTION_HISTORY_LIST'

// Message Center actions
export const GET_MESSAGE_CONTACTS = 'GET_MESSAGE_CONTACTS'
export const SET_SUBSCRIBED_CONVERSATIONS_LIST = 'SET_SUBSCRIBED_CONVERSATIONS_LIST'
export const GET_CLICKED_ON_CONTACT = 'GET_CLICKED_ON_CONTACT'
export const GET_SCROLL_DIRECTION = 'GET_SCROLL_DIRECTION'

// Profile actions
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const GET_FAMILY_PROFILE = 'GET_FAMILY_PROFILE'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const EDIT_PERSONAL_INFO = 'EDIT_PERSONAL_INFO'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const ADD_COPARENT = 'ADD_COPARENT'
export const EDIT_COPARENT = 'EDIT_COPARENT'
export const SEND_INVITITATION_COPARENT = 'SEND_INVITITATION_COPARENT'
export const RESEND_INVITITATION_COPARENT = 'RESEND_INVITITATION_COPARENT'
export const CANCEL_INVITATION_COPARENT = 'CANCEL_INVITATION_COPARENT'
export const ADD_CHILD = 'ADD_CHILD'
export const EDIT_CHILD = 'EDIT_CHILD'
export const DELETE_COPARENT = 'DELETE_COPARENT'
export const DELETE_CHILD = 'DELETE_CHILD'
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const VERIFY_PHONE_NUMBER_ON_PROFILE = 'VERIFY_PHONE_NUMBER_ON_PROFILE'

// Payment Methods actions
export const GET_BANK_ACCOUNTS = 'GET_BANK_ACCOUNTS'
export const ADD_CUSTOMER = 'ADD_CUSTOMER'
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER'
export const RETRY_CUSTOMER = 'RETRY_CUSTOMER'
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT'
export const GET_BANK_INSTITUTIONS = 'GET_BANK_INSTITUTIONS'
export const DELETE_CHECKBOOK_ACCOUNT = 'DELETE_CHECKBOOK_ACCOUNT'
export const DEFAULT_CHECKBOOK_ACCOUNT = 'DEFAULT_CHECKBOOK_ACCOUNT'
export const CHECKBOOK_LOGIN_TO_BANK = 'CHECKBOOK_LOGIN_TO_BANK'
export const CHECKBOOK_ADD_BANK_ACCOUNT = 'CHECKBOOK_ADD_BANK_ACCOUNT'
export const CHECKBOOK_ADD_MFA_ANSWER = 'CHECKBOOK_ADD_MFA_ANSWER'
export const CHECKBOOK_ADD_MD_AMOUNTS = 'CHECKBOOK_ADD_MD_AMOUNTS_URL'
export const GET_PLAID_LINK_TOKEN = 'GET_PLAID_LINK_TOKEN'
export const GET_PLAID_ACCOUNT_PROCESSOR_TOKEN = 'GET_PLAID_ACCOUNT_PROCESSOR_TOKEN'
export const GET_BANK_ACCOUNT_WITH_PLAID = 'GET_BANK_ACCOUNT_WITH_PLAID'

// Dashboard actions
export const GET_DASHBOARD_EVENTS = 'GET_DASHBOARD_EVENTS'
export const GET_DASHBOARD_EXPENSES = 'GET_DASHBOARD_EXPENSES'

// Discussion actions
export const GET_ALL_COMMENTS = 'GET_ALL_COMMENTS'
export const ADD_COMMENT = 'ADD_COMMENT'

// Braintree actions
export const GET_CLIENT_TOKEN = 'GET_CLIENT_TOKEN'
export const BRAINTREE_ADD = 'BRAINTREE_ADD'
export const BRAINTREE_UPDATE = 'BRAINTREE_UPDATE'
export const BRAINTREE_RETRY_PAYMENT = 'BRAINTREE_RETRY_PAYMENT'
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS'
export const DELETE_SUBSCRIPTION_CARD = 'DELETE_SUBSCRIPTION_CARD'
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
export const ADD_REFERRAL_CODE = 'ADD_REFERRAL_CODE'

// Pay Expense actions
export const PREVIEW_EXPENSE = 'PREVIEW_EXPENSE'
export const PAY_EXPENSE = 'PAY_EXPENSE'

// Reports
export const GET_PAY_REPORTS_PDF = 'GET_PAY_REPORTS_PDF'
export const GET_PAY_REPORTS_EXCEL = 'GET_PAY_REPORTS_EXCEL'
export const GET_MSG_REPORTS_PDF = 'GET_MSG_REPORTS_PDF'
export const GET_MSG_REPORTS_EXCEL = 'GET_MSG_REPORTS_EXCEL'

// Calendar actions
export const ADD_EVENT = 'ADD_EVENT'
export const GET_EVENTS = 'GET_EVENTS'
export const GET_PAYMENTS = 'GET_PAYMENTS'
export const GET_VISITATIONS = 'GET_VISITATIONS'
export const GET_VISITATIONS_V2 = 'GET_VISITATIONS_V2'
export const ADD_NEW_VISITATION = 'ADD_NEW_VISITATION'
export const DELETE_VISITATION = 'DELETE_VISITATION'
export const GET_SINGLE_EVENT = 'GET_SINGLE_EVENT'
export const DELETE_SINGLE_EVENT = 'DELETE_SINGLE_EVENT'
export const EDIT_SINGLE_EVENT = 'EDIT_SINGLE_EVENT'
export const EXPORT_CALENDAR = 'EXPORT_CALENDAR'
export const GET_HOLIDAYS = 'GET_HOLIDAYS'

// Notifications
export const GET_NOTIFICATIONS_ALL = 'GET_NOTIFICATIONS_ALL'
export const MARK_NOTIFICATIONS_READ_ALL = 'MARK_NOTIFICATIONS_READ_ALL'

// NLP
export const POST_NLP_SCORE = 'POST_NLP_SCORE'

// Preferences
export const POST_PAYMENTS_PREFERENCES = 'POST_PAYMENTS_PREFERENCES'
export const POST_PARENTING_SCHEDULE_PREFERENCES = 'POST_PARENTING_SCHEDULE_PREFERENCES'
export const GET_PREFERENCES = 'GET_PREFERENCES'
export const SET_PAYMENT_PREFERENCE_COMPLETED = 'SET_PAYMENT_PREFERENCE_COMPLETED'
export const SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED = 'SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED'

// Registration Progress
export const GET_REGISTRATION_PROGRESS = 'GET_REGISTRATION_PROGRESS'
export const SUBSCRIPTION_PAST_DUE_LOCK = 'SUBSCRIPTION_PAST_DUE_LOCK'
export const REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS = 'REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS'
